import { useEffect, useState } from "react";
import { Clock } from "lucide-react";
import { OFFER_END, OFFER_END_LABEL } from "./data";

const parts = (ms) => {
  const s = Math.max(0, Math.floor(ms / 1000));
  return [
    [Math.floor(s / 86400), "giorni"],
    [Math.floor((s % 86400) / 3600), "ore"],
    [Math.floor((s % 3600) / 60), "min"],
    [s % 60, "sec"],
  ];
};

export const OfferCountdown = () => {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);
  const left = OFFER_END.getTime() - now;

  return (
    <div data-testid="offer-countdown" className="mb-10 sm:mb-14 flex flex-col lg:flex-row lg:items-center justify-between gap-6 rounded-3xl border border-[#E8893F]/40 bg-[#E8893F]/10 px-6 sm:px-8 py-6">
      <div>
        <p className="flex items-center gap-2 text-xs uppercase tracking-[0.25em] font-semibold text-[#E8893F]">
          <Clock className="w-4 h-4" /> Offerta inverno sui bancali
        </p>
        <p data-testid="offer-end-date" className="mt-2 font-serif text-2xl sm:text-3xl">
          Valida fino al <em className="text-[#E8893F]">{OFFER_END_LABEL}</em>
        </p>
      </div>
      {left > 0 && (
        <div className="flex gap-2 sm:gap-3">
          {parts(left).map(([v, l]) => (
            <div key={l} className="w-[68px] sm:w-20 rounded-2xl bg-[#1A110C] border border-[#FDFBF7]/10 py-3 text-center">
              <p className="font-serif text-3xl sm:text-4xl tabular-nums leading-none">{String(v).padStart(2, "0")}</p>
              <p className="mt-1.5 text-[11px] uppercase tracking-[0.15em] text-[#F4EFE6]/80">{l}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
